module.exports = __webpack_public_path__ + "static/media/percent.262b66a3.svg";